import { queryBuilder } from '@inpart-io/devtools-iap';
import { RETRIEVE_BY_QUERY, STORE_DATA_OBJECTS } from '@inpart-io/devtools-vue';
import { DataType, dealsManager } from '@inpart-io/padme-iap';
import { dealProperties, type IDeal } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

import { LEAD_MODULE } from '@/store/lead-module';

export const RETRIEVE_BY_LEADS = 'retrieveByLeads';
export const CHANGE_ACTIVE_STAGE = 'changeActiveStage';

export const actions: ActionTree<IDeal, unknown> = {
    async [RETRIEVE_BY_LEADS](context, { leadIds, properties }: { leadIds: number[]; properties?: string }): Promise<number[]> {
        const idList: number[] = await context.dispatch(RETRIEVE_BY_QUERY, {
            query: queryBuilder.build(queryBuilder.op.and(queryBuilder.cmp.isIn('onLead', leadIds))),
            properties
        });

        return idList;
    },
    async [CHANGE_ACTIVE_STAGE](context, { dealId, dealStageId }: { dealId: number; dealStageId: number }) {
        const updatedDealWithLeadInfo = await dealsManager.changeActiveStage(dealId, dealStageId, { properties: dealProperties.CHANGE_ACTIVE_STAGE });
        if (updatedDealWithLeadInfo?.onLead instanceof Object && updatedDealWithLeadInfo?.onLead?.['@type'] === DataType.Lead) {
            await context.dispatch(`${LEAD_MODULE}/${STORE_DATA_OBJECTS}`, { dataObjectList: [updatedDealWithLeadInfo.onLead] }, { root: true });
            const leadId = updatedDealWithLeadInfo.onLead.dobjId;
            updatedDealWithLeadInfo.onLead = leadId;
        }
        void context.dispatch(STORE_DATA_OBJECTS, { dataObjectList: [updatedDealWithLeadInfo] });
    }
};
